import { gql, useQuery } from "@apollo/client";

const GET_WORK_ORDER_FOR_COMMENTS = gql`
  query getWorkOrderForComments($id: ID!) {
    getOwnOemTicketById(id: $id) {
      _id
      status
      ticketChatChannels
      ticketInternalNotesChatChannels
      workOrderType: ticketType {
        isInternal
      }
      facility {
        _id
        name
      }
    }
  }
`;

export interface WorkOrderForComments {
  _id: string;
  status: string;
  ticketChatChannels: string[];
  ticketInternalNotesChatChannels: string[];
  workOrderType: { isInternal: boolean } | null;
  facility: { _id: string; name: string } | null;
}

interface UseGetWorkOrderForCommentsResult {
  workOrder: WorkOrderForComments | null;
  loading: boolean;
}

/**
 * Slim query for the Comments tab. Returns only the fields the chat layer
 * actually reads (channel IDs, status for closed-check, facility used as
 * the connectionId for the contacts lookup inside ChatMessages).
 */
export const useGetWorkOrderForComments = (
  id: string | undefined,
): UseGetWorkOrderForCommentsResult => {
  const { data, loading } = useQuery<{
    getOwnOemTicketById: WorkOrderForComments | null;
  }>(GET_WORK_ORDER_FOR_COMMENTS, {
    variables: { id },
    skip: !id,
  });

  return {
    workOrder: data?.getOwnOemTicketById ?? null,
    loading,
  };
};
